// extracted by mini-css-extract-plugin
export default {"content":"Products_content__kT8uy","price_content":"Products_price_content__BhpDH"};